import React, { useContext, useState, useEffect, useRef } from 'react'
import Layout from '@/product/components/templates/Layout'
import CustomTable from '@/product/components/molecules/CustomTable'
import CustomSearch from '@/product/components/molecules/CustomSearch'
import { Button } from '@mui/material'
import { mapData } from '@/product/common/components'
import { useFormik } from 'formik'
import CustomCommonContext from '@/custom/context/common/commonContext'
import CustomDialog from '@/product/components/organisms/Dialog'
import * as Yup from 'yup'
import FullScreenPopup from '@/product/components/organisms/FullScreenPopup'
import SecondaryButton from '@/product/components/atoms/SecondaryButton'
import PrimaryButton from '@/product/components/atoms/PrimaryButton'
import TwofactorContext from '@/product/context/twoFactor/twofactorContext'
import { request } from 'bwip-js'
import AuthContext from '@/product/context/auth/authContext'
import AlertContext from '@/product/context/alert/alertContext'

const TwoFactor = () => {
    const alertContext = useContext(AlertContext)
    const { setAlert } = alertContext
    const twofactorContext = useContext(TwofactorContext)
    const authContext = useContext(AuthContext)
    const {
        get2faRequest,
        request_data,
        verify2fa,
        revoke2fa,
        responseStatus: responseStatusFactor,
        clearResponse: clearResponseFactor,
    } = twofactorContext
    const { user, isAuthenticated, loadUser } = authContext

    const [changeStatus, setChangeStatus] = useState(false)
    const [updated, setUpdated] = useState(false)
    const changeChangeStatus = () => {
        setChangeStatus(!changeStatus)
    }
    console.log(changeStatus, 'chagrr')
    const handleFunction = () => {
        get2faRequest({})
        setUpdated(true)
    }

    const validationArray = Yup.object({
        otp: Yup.string().required('Required!'),
    })

    const formik = useFormik({
        initialValues: {
            otp: '',
            secret_key: '',
            admin_id: 0,
            activate: true,
        },
        validateOnBlur: false,
        validationSchema: validationArray,
        onSubmit: (values) => {
            values.admin_id = user.admin_id
            verify2fa(values, 'verify')
            setChangeStatus(false)
        },
    })

    const details = [
        {
            label: ' Please enter OTP shown in the Authenticator app to verify',
            placeholder: '',
            type: 'textarea',
            class: 'col-12',
            name: 'otp',
            formik: formik,
        },
    ]

    useEffect(() => {
        if (request_data && request_data.base64Data && updated) {
            console.log(request_data, 'dattttt')
            formik.values.secret_key = request_data.secret.base32
            setChangeStatus(true)
        }
    }, [request_data])

    useEffect(() => {
        if (responseStatusFactor && responseStatusFactor.from === 'verify') {
            setAlert(responseStatusFactor.message, responseStatusFactor.status)
            loadUser()
        } else if (
            responseStatusFactor &&
            responseStatusFactor.from === 'revoke'
        ) {
            setAlert(responseStatusFactor.message, responseStatusFactor.status)
            loadUser()
        }
        clearResponseFactor()
    }, [responseStatusFactor])

    const handleRevokeFunction = () => {
        let values = {
            secret_key: user['2fa_token'],
            admin_id: user.admin_id,
        }
        revoke2fa(values, 'revoke')
    }

    return (
        <Layout>
            <div className="dashboard staticPages">
                <div className="d-flex justify-content-between align-items-center mt-4 flex-wrap">
                    Two-factor authentication is not enabled Activate two-factor
                    authentication (2FA) for increased security and to be able
                    to access Admin portal on the go
                    {user && user['2fa_enable'] ? (
                        <Button
                            id="taxCodelist_new"
                            variant="outlined"
                            className="btnOutlined"
                            onClick={() => handleRevokeFunction()}
                        >
                            <span className="material-icons">security</span>
                            Revoke 2FA
                        </Button>
                    ) : (
                        <Button
                            id="taxCodelist_new"
                            variant="outlined"
                            className="btnOutlined"
                            onClick={() => handleFunction()}
                        >
                            <span className="material-icons">security</span>
                            Activate 2FA
                        </Button>
                    )}
                </div>
            </div>
            <CustomDialog
                title={'Activate 2FA'}
                open={changeStatus}
                function={changeChangeStatus}
            >
                <h5>
                    Scan this QR code with your authentication application
                    (Google Authenticator, Microsoft Authenticator, Authy, or
                    any other)
                </h5>
                <div className="pclImg">
                    <img src={request_data.base64Data} alt={''} />
                </div>
                Or manually enter this secret key
                <div>{request_data.secret.base32}</div>
                <div className="row">{Object.values(mapData(details))}</div>
                <div className="actionWrapper">
                    <Button
                        id="taxCodeList_cancel"
                        onClick={() => setChangeStatus(false)}
                    >
                        Cancel
                    </Button>
                    <PrimaryButton
                        id="twofactor_verify"
                        type="submit"
                        label="Verify"
                        onClick={() => formik.handleSubmit()}
                    />
                </div>
            </CustomDialog>
        </Layout>
    )
}
export default TwoFactor
